module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-48.f0575c4d.png";